// Generated by Melange

import * as Caml_module from "melange.js/caml_module.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/commonapis/gen/buhta_common_v1_iso4217.ml",
      227,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "Currency"
                    ]]
                },
                "V1"
              ]]
          },
          "Common"
        ]]
    });

const Common = Caml_module.init_mod([
      "proto/commonapis/gen/buhta_common_v1_iso4217.ml",
      425,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "Currency"
              ]]
          },
          "V1"
        ]]
    });

const V1 = Caml_module.init_mod([
      "proto/commonapis/gen/buhta_common_v1_iso4217.ml",
      621,
      10
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "Currency"
        ]]
    });

const Currency = Caml_module.init_mod([
      "proto/commonapis/gen/buhta_common_v1_iso4217.ml",
      813,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.common.v1.Currency";
}

function to_int(param) {
  switch (param) {
    case /* CURRENCY_UNSPECIFIED */0 :
        return 0;
    case /* ALL */1 :
        return 8;
    case /* DZD */2 :
        return 12;
    case /* ARS */3 :
        return 32;
    case /* AUD */4 :
        return 36;
    case /* BSD */5 :
        return 44;
    case /* BHD */6 :
        return 48;
    case /* BDT */7 :
        return 50;
    case /* AMD */8 :
        return 51;
    case /* BBD */9 :
        return 52;
    case /* BMD */10 :
        return 60;
    case /* BTN */11 :
        return 64;
    case /* BOB */12 :
        return 68;
    case /* BWP */13 :
        return 72;
    case /* BZD */14 :
        return 84;
    case /* SBD */15 :
        return 90;
    case /* BND */16 :
        return 96;
    case /* MMK */17 :
        return 104;
    case /* BIF */18 :
        return 108;
    case /* KHR */19 :
        return 116;
    case /* CAD */20 :
        return 124;
    case /* CVE */21 :
        return 132;
    case /* KYD */22 :
        return 136;
    case /* LKR */23 :
        return 144;
    case /* CLP */24 :
        return 152;
    case /* CNY */25 :
        return 156;
    case /* COP */26 :
        return 170;
    case /* KMF */27 :
        return 174;
    case /* CRC */28 :
        return 188;
    case /* HRK */29 :
        return 191;
    case /* CUP */30 :
        return 192;
    case /* CZK */31 :
        return 203;
    case /* DKK */32 :
        return 208;
    case /* DOP */33 :
        return 214;
    case /* SVC */34 :
        return 222;
    case /* ETB */35 :
        return 230;
    case /* ERN */36 :
        return 232;
    case /* FKP */37 :
        return 238;
    case /* FJD */38 :
        return 242;
    case /* DJF */39 :
        return 262;
    case /* GMD */40 :
        return 270;
    case /* GIP */41 :
        return 292;
    case /* GTQ */42 :
        return 320;
    case /* GNF */43 :
        return 324;
    case /* GYD */44 :
        return 328;
    case /* HTG */45 :
        return 332;
    case /* HNL */46 :
        return 340;
    case /* HKD */47 :
        return 344;
    case /* HUF */48 :
        return 348;
    case /* ISK */49 :
        return 352;
    case /* INR */50 :
        return 356;
    case /* IDR */51 :
        return 360;
    case /* IRR */52 :
        return 364;
    case /* IQD */53 :
        return 368;
    case /* ILS */54 :
        return 376;
    case /* JMD */55 :
        return 388;
    case /* JPY */56 :
        return 392;
    case /* KZT */57 :
        return 398;
    case /* JOD */58 :
        return 400;
    case /* KES */59 :
        return 404;
    case /* KPW */60 :
        return 408;
    case /* KRW */61 :
        return 410;
    case /* KWD */62 :
        return 414;
    case /* KGS */63 :
        return 417;
    case /* LAK */64 :
        return 418;
    case /* LBP */65 :
        return 422;
    case /* LSL */66 :
        return 426;
    case /* LRD */67 :
        return 430;
    case /* LYD */68 :
        return 434;
    case /* LTL */69 :
        return 440;
    case /* MOP */70 :
        return 446;
    case /* MWK */71 :
        return 454;
    case /* MYR */72 :
        return 458;
    case /* MVR */73 :
        return 462;
    case /* MRO */74 :
        return 478;
    case /* MUR */75 :
        return 480;
    case /* MXN */76 :
        return 484;
    case /* MNT */77 :
        return 496;
    case /* MDL */78 :
        return 498;
    case /* MAD */79 :
        return 504;
    case /* OMR */80 :
        return 512;
    case /* NAD */81 :
        return 516;
    case /* NPR */82 :
        return 524;
    case /* ANG */83 :
        return 532;
    case /* AWG */84 :
        return 533;
    case /* VUV */85 :
        return 548;
    case /* NZD */86 :
        return 554;
    case /* NIO */87 :
        return 558;
    case /* NGN */88 :
        return 566;
    case /* NOK */89 :
        return 578;
    case /* PKR */90 :
        return 586;
    case /* PAB */91 :
        return 590;
    case /* PGK */92 :
        return 598;
    case /* PYG */93 :
        return 600;
    case /* PEN */94 :
        return 604;
    case /* PHP */95 :
        return 608;
    case /* QAR */96 :
        return 634;
    case /* RUB */97 :
        return 643;
    case /* RWF */98 :
        return 646;
    case /* SHP */99 :
        return 654;
    case /* STD */100 :
        return 678;
    case /* SAR */101 :
        return 682;
    case /* SCR */102 :
        return 690;
    case /* SLL */103 :
        return 694;
    case /* SGD */104 :
        return 702;
    case /* VND */105 :
        return 704;
    case /* SOS */106 :
        return 706;
    case /* ZAR */107 :
        return 710;
    case /* SSP */108 :
        return 728;
    case /* SZL */109 :
        return 748;
    case /* SEK */110 :
        return 752;
    case /* CHF */111 :
        return 756;
    case /* SYP */112 :
        return 760;
    case /* THB */113 :
        return 764;
    case /* TOP */114 :
        return 776;
    case /* TTD */115 :
        return 780;
    case /* AED */116 :
        return 784;
    case /* TND */117 :
        return 788;
    case /* UGX */118 :
        return 800;
    case /* MKD */119 :
        return 807;
    case /* EGP */120 :
        return 818;
    case /* GBP */121 :
        return 826;
    case /* TZS */122 :
        return 834;
    case /* USD */123 :
        return 840;
    case /* UYU */124 :
        return 858;
    case /* UZS */125 :
        return 860;
    case /* WST */126 :
        return 882;
    case /* YER */127 :
        return 886;
    case /* TWD */128 :
        return 901;
    case /* CUC */129 :
        return 931;
    case /* ZWL */130 :
        return 932;
    case /* TMT */131 :
        return 934;
    case /* GHS */132 :
        return 936;
    case /* VEF */133 :
        return 937;
    case /* SDG */134 :
        return 938;
    case /* UYI */135 :
        return 940;
    case /* RSD */136 :
        return 941;
    case /* MZN */137 :
        return 943;
    case /* AZN */138 :
        return 944;
    case /* RON */139 :
        return 946;
    case /* CHE */140 :
        return 947;
    case /* CHW */141 :
        return 948;
    case /* TRY */142 :
        return 949;
    case /* XAF */143 :
        return 950;
    case /* XCD */144 :
        return 951;
    case /* XOF */145 :
        return 952;
    case /* XPF */146 :
        return 953;
    case /* XBA */147 :
        return 955;
    case /* XBB */148 :
        return 956;
    case /* XBC */149 :
        return 957;
    case /* XBD */150 :
        return 958;
    case /* XAU */151 :
        return 959;
    case /* XDR */152 :
        return 960;
    case /* XAG */153 :
        return 961;
    case /* XPT */154 :
        return 962;
    case /* XPD */155 :
        return 964;
    case /* XUA */156 :
        return 965;
    case /* ZMW */157 :
        return 967;
    case /* SRD */158 :
        return 968;
    case /* MGA */159 :
        return 969;
    case /* COU */160 :
        return 970;
    case /* AFN */161 :
        return 971;
    case /* TJS */162 :
        return 972;
    case /* AOA */163 :
        return 973;
    case /* BYR */164 :
        return 974;
    case /* BGN */165 :
        return 975;
    case /* CDF */166 :
        return 976;
    case /* BAM */167 :
        return 977;
    case /* EUR */168 :
        return 978;
    case /* MXV */169 :
        return 979;
    case /* UAH */170 :
        return 980;
    case /* GEL */171 :
        return 981;
    case /* BOV */172 :
        return 984;
    case /* PLN */173 :
        return 985;
    case /* BRL */174 :
        return 986;
    case /* CLF */175 :
        return 990;
    case /* XSU */176 :
        return 994;
    case /* USN */177 :
        return 997;
    
  }
}

function from_int_exn(n) {
  if (n >= 203) {
    if (n < 271) {
      if (!(n > 269 || n < 243)) {
        if (n !== 262) {
          return Ocaml_protoc_plugin__Result.raise({
                      NAME: "Unknown_enum_value",
                      VAL: n
                    });
        } else {
          return /* DJF */39;
        }
      }
      if (n >= 270) {
        return /* GMD */40;
      }
      switch (n) {
        case 203 :
            return /* CZK */31;
        case 208 :
            return /* DKK */32;
        case 214 :
            return /* DOP */33;
        case 222 :
            return /* SVC */34;
        case 230 :
            return /* ETB */35;
        case 232 :
            return /* ERN */36;
        case 238 :
            return /* FKP */37;
        case 204 :
        case 205 :
        case 206 :
        case 207 :
        case 209 :
        case 210 :
        case 211 :
        case 212 :
        case 213 :
        case 215 :
        case 216 :
        case 217 :
        case 218 :
        case 219 :
        case 220 :
        case 221 :
        case 223 :
        case 224 :
        case 225 :
        case 226 :
        case 227 :
        case 228 :
        case 229 :
        case 231 :
        case 233 :
        case 234 :
        case 235 :
        case 236 :
        case 237 :
        case 239 :
        case 240 :
        case 241 :
            return Ocaml_protoc_plugin__Result.raise({
                        NAME: "Unknown_enum_value",
                        VAL: n
                      });
        case 242 :
            return /* FJD */38;
        
      }
    } else {
      if (n < 320) {
        if (n !== 292) {
          return Ocaml_protoc_plugin__Result.raise({
                      NAME: "Unknown_enum_value",
                      VAL: n
                    });
        } else {
          return /* GIP */41;
        }
      }
      if (n >= 998) {
        return Ocaml_protoc_plugin__Result.raise({
                    NAME: "Unknown_enum_value",
                    VAL: n
                  });
      }
      switch (n) {
        case 320 :
            return /* GTQ */42;
        case 324 :
            return /* GNF */43;
        case 328 :
            return /* GYD */44;
        case 332 :
            return /* HTG */45;
        case 340 :
            return /* HNL */46;
        case 344 :
            return /* HKD */47;
        case 348 :
            return /* HUF */48;
        case 352 :
            return /* ISK */49;
        case 356 :
            return /* INR */50;
        case 360 :
            return /* IDR */51;
        case 364 :
            return /* IRR */52;
        case 368 :
            return /* IQD */53;
        case 376 :
            return /* ILS */54;
        case 388 :
            return /* JMD */55;
        case 392 :
            return /* JPY */56;
        case 398 :
            return /* KZT */57;
        case 400 :
            return /* JOD */58;
        case 404 :
            return /* KES */59;
        case 408 :
            return /* KPW */60;
        case 410 :
            return /* KRW */61;
        case 414 :
            return /* KWD */62;
        case 417 :
            return /* KGS */63;
        case 418 :
            return /* LAK */64;
        case 422 :
            return /* LBP */65;
        case 426 :
            return /* LSL */66;
        case 430 :
            return /* LRD */67;
        case 434 :
            return /* LYD */68;
        case 440 :
            return /* LTL */69;
        case 446 :
            return /* MOP */70;
        case 454 :
            return /* MWK */71;
        case 458 :
            return /* MYR */72;
        case 462 :
            return /* MVR */73;
        case 478 :
            return /* MRO */74;
        case 480 :
            return /* MUR */75;
        case 484 :
            return /* MXN */76;
        case 496 :
            return /* MNT */77;
        case 498 :
            return /* MDL */78;
        case 504 :
            return /* MAD */79;
        case 512 :
            return /* OMR */80;
        case 516 :
            return /* NAD */81;
        case 524 :
            return /* NPR */82;
        case 532 :
            return /* ANG */83;
        case 533 :
            return /* AWG */84;
        case 548 :
            return /* VUV */85;
        case 554 :
            return /* NZD */86;
        case 558 :
            return /* NIO */87;
        case 566 :
            return /* NGN */88;
        case 578 :
            return /* NOK */89;
        case 586 :
            return /* PKR */90;
        case 590 :
            return /* PAB */91;
        case 598 :
            return /* PGK */92;
        case 600 :
            return /* PYG */93;
        case 604 :
            return /* PEN */94;
        case 608 :
            return /* PHP */95;
        case 634 :
            return /* QAR */96;
        case 643 :
            return /* RUB */97;
        case 646 :
            return /* RWF */98;
        case 654 :
            return /* SHP */99;
        case 678 :
            return /* STD */100;
        case 682 :
            return /* SAR */101;
        case 690 :
            return /* SCR */102;
        case 694 :
            return /* SLL */103;
        case 702 :
            return /* SGD */104;
        case 704 :
            return /* VND */105;
        case 706 :
            return /* SOS */106;
        case 710 :
            return /* ZAR */107;
        case 728 :
            return /* SSP */108;
        case 748 :
            return /* SZL */109;
        case 752 :
            return /* SEK */110;
        case 756 :
            return /* CHF */111;
        case 760 :
            return /* SYP */112;
        case 764 :
            return /* THB */113;
        case 776 :
            return /* TOP */114;
        case 780 :
            return /* TTD */115;
        case 784 :
            return /* AED */116;
        case 788 :
            return /* TND */117;
        case 800 :
            return /* UGX */118;
        case 807 :
            return /* MKD */119;
        case 818 :
            return /* EGP */120;
        case 826 :
            return /* GBP */121;
        case 834 :
            return /* TZS */122;
        case 840 :
            return /* USD */123;
        case 858 :
            return /* UYU */124;
        case 860 :
            return /* UZS */125;
        case 882 :
            return /* WST */126;
        case 886 :
            return /* YER */127;
        case 901 :
            return /* TWD */128;
        case 931 :
            return /* CUC */129;
        case 932 :
            return /* ZWL */130;
        case 934 :
            return /* TMT */131;
        case 936 :
            return /* GHS */132;
        case 937 :
            return /* VEF */133;
        case 938 :
            return /* SDG */134;
        case 940 :
            return /* UYI */135;
        case 941 :
            return /* RSD */136;
        case 943 :
            return /* MZN */137;
        case 944 :
            return /* AZN */138;
        case 946 :
            return /* RON */139;
        case 947 :
            return /* CHE */140;
        case 948 :
            return /* CHW */141;
        case 949 :
            return /* TRY */142;
        case 950 :
            return /* XAF */143;
        case 951 :
            return /* XCD */144;
        case 952 :
            return /* XOF */145;
        case 953 :
            return /* XPF */146;
        case 955 :
            return /* XBA */147;
        case 956 :
            return /* XBB */148;
        case 957 :
            return /* XBC */149;
        case 958 :
            return /* XBD */150;
        case 959 :
            return /* XAU */151;
        case 960 :
            return /* XDR */152;
        case 961 :
            return /* XAG */153;
        case 962 :
            return /* XPT */154;
        case 964 :
            return /* XPD */155;
        case 965 :
            return /* XUA */156;
        case 967 :
            return /* ZMW */157;
        case 968 :
            return /* SRD */158;
        case 969 :
            return /* MGA */159;
        case 970 :
            return /* COU */160;
        case 971 :
            return /* AFN */161;
        case 972 :
            return /* TJS */162;
        case 973 :
            return /* AOA */163;
        case 974 :
            return /* BYR */164;
        case 975 :
            return /* BGN */165;
        case 976 :
            return /* CDF */166;
        case 977 :
            return /* BAM */167;
        case 978 :
            return /* EUR */168;
        case 979 :
            return /* MXV */169;
        case 980 :
            return /* UAH */170;
        case 981 :
            return /* GEL */171;
        case 984 :
            return /* BOV */172;
        case 985 :
            return /* PLN */173;
        case 986 :
            return /* BRL */174;
        case 990 :
            return /* CLF */175;
        case 994 :
            return /* XSU */176;
        case 321 :
        case 322 :
        case 323 :
        case 325 :
        case 326 :
        case 327 :
        case 329 :
        case 330 :
        case 331 :
        case 333 :
        case 334 :
        case 335 :
        case 336 :
        case 337 :
        case 338 :
        case 339 :
        case 341 :
        case 342 :
        case 343 :
        case 345 :
        case 346 :
        case 347 :
        case 349 :
        case 350 :
        case 351 :
        case 353 :
        case 354 :
        case 355 :
        case 357 :
        case 358 :
        case 359 :
        case 361 :
        case 362 :
        case 363 :
        case 365 :
        case 366 :
        case 367 :
        case 369 :
        case 370 :
        case 371 :
        case 372 :
        case 373 :
        case 374 :
        case 375 :
        case 377 :
        case 378 :
        case 379 :
        case 380 :
        case 381 :
        case 382 :
        case 383 :
        case 384 :
        case 385 :
        case 386 :
        case 387 :
        case 389 :
        case 390 :
        case 391 :
        case 393 :
        case 394 :
        case 395 :
        case 396 :
        case 397 :
        case 399 :
        case 401 :
        case 402 :
        case 403 :
        case 405 :
        case 406 :
        case 407 :
        case 409 :
        case 411 :
        case 412 :
        case 413 :
        case 415 :
        case 416 :
        case 419 :
        case 420 :
        case 421 :
        case 423 :
        case 424 :
        case 425 :
        case 427 :
        case 428 :
        case 429 :
        case 431 :
        case 432 :
        case 433 :
        case 435 :
        case 436 :
        case 437 :
        case 438 :
        case 439 :
        case 441 :
        case 442 :
        case 443 :
        case 444 :
        case 445 :
        case 447 :
        case 448 :
        case 449 :
        case 450 :
        case 451 :
        case 452 :
        case 453 :
        case 455 :
        case 456 :
        case 457 :
        case 459 :
        case 460 :
        case 461 :
        case 463 :
        case 464 :
        case 465 :
        case 466 :
        case 467 :
        case 468 :
        case 469 :
        case 470 :
        case 471 :
        case 472 :
        case 473 :
        case 474 :
        case 475 :
        case 476 :
        case 477 :
        case 479 :
        case 481 :
        case 482 :
        case 483 :
        case 485 :
        case 486 :
        case 487 :
        case 488 :
        case 489 :
        case 490 :
        case 491 :
        case 492 :
        case 493 :
        case 494 :
        case 495 :
        case 497 :
        case 499 :
        case 500 :
        case 501 :
        case 502 :
        case 503 :
        case 505 :
        case 506 :
        case 507 :
        case 508 :
        case 509 :
        case 510 :
        case 511 :
        case 513 :
        case 514 :
        case 515 :
        case 517 :
        case 518 :
        case 519 :
        case 520 :
        case 521 :
        case 522 :
        case 523 :
        case 525 :
        case 526 :
        case 527 :
        case 528 :
        case 529 :
        case 530 :
        case 531 :
        case 534 :
        case 535 :
        case 536 :
        case 537 :
        case 538 :
        case 539 :
        case 540 :
        case 541 :
        case 542 :
        case 543 :
        case 544 :
        case 545 :
        case 546 :
        case 547 :
        case 549 :
        case 550 :
        case 551 :
        case 552 :
        case 553 :
        case 555 :
        case 556 :
        case 557 :
        case 559 :
        case 560 :
        case 561 :
        case 562 :
        case 563 :
        case 564 :
        case 565 :
        case 567 :
        case 568 :
        case 569 :
        case 570 :
        case 571 :
        case 572 :
        case 573 :
        case 574 :
        case 575 :
        case 576 :
        case 577 :
        case 579 :
        case 580 :
        case 581 :
        case 582 :
        case 583 :
        case 584 :
        case 585 :
        case 587 :
        case 588 :
        case 589 :
        case 591 :
        case 592 :
        case 593 :
        case 594 :
        case 595 :
        case 596 :
        case 597 :
        case 599 :
        case 601 :
        case 602 :
        case 603 :
        case 605 :
        case 606 :
        case 607 :
        case 609 :
        case 610 :
        case 611 :
        case 612 :
        case 613 :
        case 614 :
        case 615 :
        case 616 :
        case 617 :
        case 618 :
        case 619 :
        case 620 :
        case 621 :
        case 622 :
        case 623 :
        case 624 :
        case 625 :
        case 626 :
        case 627 :
        case 628 :
        case 629 :
        case 630 :
        case 631 :
        case 632 :
        case 633 :
        case 635 :
        case 636 :
        case 637 :
        case 638 :
        case 639 :
        case 640 :
        case 641 :
        case 642 :
        case 644 :
        case 645 :
        case 647 :
        case 648 :
        case 649 :
        case 650 :
        case 651 :
        case 652 :
        case 653 :
        case 655 :
        case 656 :
        case 657 :
        case 658 :
        case 659 :
        case 660 :
        case 661 :
        case 662 :
        case 663 :
        case 664 :
        case 665 :
        case 666 :
        case 667 :
        case 668 :
        case 669 :
        case 670 :
        case 671 :
        case 672 :
        case 673 :
        case 674 :
        case 675 :
        case 676 :
        case 677 :
        case 679 :
        case 680 :
        case 681 :
        case 683 :
        case 684 :
        case 685 :
        case 686 :
        case 687 :
        case 688 :
        case 689 :
        case 691 :
        case 692 :
        case 693 :
        case 695 :
        case 696 :
        case 697 :
        case 698 :
        case 699 :
        case 700 :
        case 701 :
        case 703 :
        case 705 :
        case 707 :
        case 708 :
        case 709 :
        case 711 :
        case 712 :
        case 713 :
        case 714 :
        case 715 :
        case 716 :
        case 717 :
        case 718 :
        case 719 :
        case 720 :
        case 721 :
        case 722 :
        case 723 :
        case 724 :
        case 725 :
        case 726 :
        case 727 :
        case 729 :
        case 730 :
        case 731 :
        case 732 :
        case 733 :
        case 734 :
        case 735 :
        case 736 :
        case 737 :
        case 738 :
        case 739 :
        case 740 :
        case 741 :
        case 742 :
        case 743 :
        case 744 :
        case 745 :
        case 746 :
        case 747 :
        case 749 :
        case 750 :
        case 751 :
        case 753 :
        case 754 :
        case 755 :
        case 757 :
        case 758 :
        case 759 :
        case 761 :
        case 762 :
        case 763 :
        case 765 :
        case 766 :
        case 767 :
        case 768 :
        case 769 :
        case 770 :
        case 771 :
        case 772 :
        case 773 :
        case 774 :
        case 775 :
        case 777 :
        case 778 :
        case 779 :
        case 781 :
        case 782 :
        case 783 :
        case 785 :
        case 786 :
        case 787 :
        case 789 :
        case 790 :
        case 791 :
        case 792 :
        case 793 :
        case 794 :
        case 795 :
        case 796 :
        case 797 :
        case 798 :
        case 799 :
        case 801 :
        case 802 :
        case 803 :
        case 804 :
        case 805 :
        case 806 :
        case 808 :
        case 809 :
        case 810 :
        case 811 :
        case 812 :
        case 813 :
        case 814 :
        case 815 :
        case 816 :
        case 817 :
        case 819 :
        case 820 :
        case 821 :
        case 822 :
        case 823 :
        case 824 :
        case 825 :
        case 827 :
        case 828 :
        case 829 :
        case 830 :
        case 831 :
        case 832 :
        case 833 :
        case 835 :
        case 836 :
        case 837 :
        case 838 :
        case 839 :
        case 841 :
        case 842 :
        case 843 :
        case 844 :
        case 845 :
        case 846 :
        case 847 :
        case 848 :
        case 849 :
        case 850 :
        case 851 :
        case 852 :
        case 853 :
        case 854 :
        case 855 :
        case 856 :
        case 857 :
        case 859 :
        case 861 :
        case 862 :
        case 863 :
        case 864 :
        case 865 :
        case 866 :
        case 867 :
        case 868 :
        case 869 :
        case 870 :
        case 871 :
        case 872 :
        case 873 :
        case 874 :
        case 875 :
        case 876 :
        case 877 :
        case 878 :
        case 879 :
        case 880 :
        case 881 :
        case 883 :
        case 884 :
        case 885 :
        case 887 :
        case 888 :
        case 889 :
        case 890 :
        case 891 :
        case 892 :
        case 893 :
        case 894 :
        case 895 :
        case 896 :
        case 897 :
        case 898 :
        case 899 :
        case 900 :
        case 902 :
        case 903 :
        case 904 :
        case 905 :
        case 906 :
        case 907 :
        case 908 :
        case 909 :
        case 910 :
        case 911 :
        case 912 :
        case 913 :
        case 914 :
        case 915 :
        case 916 :
        case 917 :
        case 918 :
        case 919 :
        case 920 :
        case 921 :
        case 922 :
        case 923 :
        case 924 :
        case 925 :
        case 926 :
        case 927 :
        case 928 :
        case 929 :
        case 930 :
        case 933 :
        case 935 :
        case 939 :
        case 942 :
        case 945 :
        case 954 :
        case 963 :
        case 966 :
        case 982 :
        case 983 :
        case 987 :
        case 988 :
        case 989 :
        case 991 :
        case 992 :
        case 993 :
        case 995 :
        case 996 :
            return Ocaml_protoc_plugin__Result.raise({
                        NAME: "Unknown_enum_value",
                        VAL: n
                      });
        case 997 :
            return /* USN */177;
        
      }
    }
  } else if (n >= 117) {
    if (n >= 157) {
      switch (n) {
        case 170 :
            return /* COP */26;
        case 174 :
            return /* KMF */27;
        case 188 :
            return /* CRC */28;
        case 171 :
        case 172 :
        case 173 :
        case 175 :
        case 176 :
        case 177 :
        case 178 :
        case 179 :
        case 180 :
        case 181 :
        case 182 :
        case 183 :
        case 184 :
        case 185 :
        case 186 :
        case 187 :
        case 189 :
        case 190 :
            return Ocaml_protoc_plugin__Result.raise({
                        NAME: "Unknown_enum_value",
                        VAL: n
                      });
        case 191 :
            return /* HRK */29;
        case 192 :
            return /* CUP */30;
        default:
          return Ocaml_protoc_plugin__Result.raise({
                      NAME: "Unknown_enum_value",
                      VAL: n
                    });
      }
    } else {
      if (n < 124) {
        return Ocaml_protoc_plugin__Result.raise({
                    NAME: "Unknown_enum_value",
                    VAL: n
                  });
      }
      switch (n) {
        case 124 :
            return /* CAD */20;
        case 132 :
            return /* CVE */21;
        case 136 :
            return /* KYD */22;
        case 144 :
            return /* LKR */23;
        case 152 :
            return /* CLP */24;
        case 125 :
        case 126 :
        case 127 :
        case 128 :
        case 129 :
        case 130 :
        case 131 :
        case 133 :
        case 134 :
        case 135 :
        case 137 :
        case 138 :
        case 139 :
        case 140 :
        case 141 :
        case 142 :
        case 143 :
        case 145 :
        case 146 :
        case 147 :
        case 148 :
        case 149 :
        case 150 :
        case 151 :
        case 153 :
        case 154 :
        case 155 :
            return Ocaml_protoc_plugin__Result.raise({
                        NAME: "Unknown_enum_value",
                        VAL: n
                      });
        case 156 :
            return /* CNY */25;
        
      }
    }
  } else if (n >= 73) {
    if (n < 84) {
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_value",
                  VAL: n
                });
    }
    switch (n) {
      case 84 :
          return /* BZD */14;
      case 90 :
          return /* SBD */15;
      case 96 :
          return /* BND */16;
      case 104 :
          return /* MMK */17;
      case 108 :
          return /* BIF */18;
      case 85 :
      case 86 :
      case 87 :
      case 88 :
      case 89 :
      case 91 :
      case 92 :
      case 93 :
      case 94 :
      case 95 :
      case 97 :
      case 98 :
      case 99 :
      case 100 :
      case 101 :
      case 102 :
      case 103 :
      case 105 :
      case 106 :
      case 107 :
      case 109 :
      case 110 :
      case 111 :
      case 112 :
      case 113 :
      case 114 :
      case 115 :
          return Ocaml_protoc_plugin__Result.raise({
                      NAME: "Unknown_enum_value",
                      VAL: n
                    });
      case 116 :
          return /* KHR */19;
      
    }
  } else {
    if (n < 0) {
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_value",
                  VAL: n
                });
    }
    switch (n) {
      case 0 :
          return /* CURRENCY_UNSPECIFIED */0;
      case 8 :
          return /* ALL */1;
      case 12 :
          return /* DZD */2;
      case 32 :
          return /* ARS */3;
      case 36 :
          return /* AUD */4;
      case 44 :
          return /* BSD */5;
      case 48 :
          return /* BHD */6;
      case 50 :
          return /* BDT */7;
      case 51 :
          return /* AMD */8;
      case 52 :
          return /* BBD */9;
      case 60 :
          return /* BMD */10;
      case 64 :
          return /* BTN */11;
      case 68 :
          return /* BOB */12;
      case 1 :
      case 2 :
      case 3 :
      case 4 :
      case 5 :
      case 6 :
      case 7 :
      case 9 :
      case 10 :
      case 11 :
      case 13 :
      case 14 :
      case 15 :
      case 16 :
      case 17 :
      case 18 :
      case 19 :
      case 20 :
      case 21 :
      case 22 :
      case 23 :
      case 24 :
      case 25 :
      case 26 :
      case 27 :
      case 28 :
      case 29 :
      case 30 :
      case 31 :
      case 33 :
      case 34 :
      case 35 :
      case 37 :
      case 38 :
      case 39 :
      case 40 :
      case 41 :
      case 42 :
      case 43 :
      case 45 :
      case 46 :
      case 47 :
      case 49 :
      case 53 :
      case 54 :
      case 55 :
      case 56 :
      case 57 :
      case 58 :
      case 59 :
      case 61 :
      case 62 :
      case 63 :
      case 65 :
      case 66 :
      case 67 :
      case 69 :
      case 70 :
      case 71 :
          return Ocaml_protoc_plugin__Result.raise({
                      NAME: "Unknown_enum_value",
                      VAL: n
                    });
      case 72 :
          return /* BWP */13;
      
    }
  }
}

function from_int(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return from_int_exn(e);
            });
}

function to_string(param) {
  switch (param) {
    case /* CURRENCY_UNSPECIFIED */0 :
        return "CURRENCY_UNSPECIFIED";
    case /* ALL */1 :
        return "ALL";
    case /* DZD */2 :
        return "DZD";
    case /* ARS */3 :
        return "ARS";
    case /* AUD */4 :
        return "AUD";
    case /* BSD */5 :
        return "BSD";
    case /* BHD */6 :
        return "BHD";
    case /* BDT */7 :
        return "BDT";
    case /* AMD */8 :
        return "AMD";
    case /* BBD */9 :
        return "BBD";
    case /* BMD */10 :
        return "BMD";
    case /* BTN */11 :
        return "BTN";
    case /* BOB */12 :
        return "BOB";
    case /* BWP */13 :
        return "BWP";
    case /* BZD */14 :
        return "BZD";
    case /* SBD */15 :
        return "SBD";
    case /* BND */16 :
        return "BND";
    case /* MMK */17 :
        return "MMK";
    case /* BIF */18 :
        return "BIF";
    case /* KHR */19 :
        return "KHR";
    case /* CAD */20 :
        return "CAD";
    case /* CVE */21 :
        return "CVE";
    case /* KYD */22 :
        return "KYD";
    case /* LKR */23 :
        return "LKR";
    case /* CLP */24 :
        return "CLP";
    case /* CNY */25 :
        return "CNY";
    case /* COP */26 :
        return "COP";
    case /* KMF */27 :
        return "KMF";
    case /* CRC */28 :
        return "CRC";
    case /* HRK */29 :
        return "HRK";
    case /* CUP */30 :
        return "CUP";
    case /* CZK */31 :
        return "CZK";
    case /* DKK */32 :
        return "DKK";
    case /* DOP */33 :
        return "DOP";
    case /* SVC */34 :
        return "SVC";
    case /* ETB */35 :
        return "ETB";
    case /* ERN */36 :
        return "ERN";
    case /* FKP */37 :
        return "FKP";
    case /* FJD */38 :
        return "FJD";
    case /* DJF */39 :
        return "DJF";
    case /* GMD */40 :
        return "GMD";
    case /* GIP */41 :
        return "GIP";
    case /* GTQ */42 :
        return "GTQ";
    case /* GNF */43 :
        return "GNF";
    case /* GYD */44 :
        return "GYD";
    case /* HTG */45 :
        return "HTG";
    case /* HNL */46 :
        return "HNL";
    case /* HKD */47 :
        return "HKD";
    case /* HUF */48 :
        return "HUF";
    case /* ISK */49 :
        return "ISK";
    case /* INR */50 :
        return "INR";
    case /* IDR */51 :
        return "IDR";
    case /* IRR */52 :
        return "IRR";
    case /* IQD */53 :
        return "IQD";
    case /* ILS */54 :
        return "ILS";
    case /* JMD */55 :
        return "JMD";
    case /* JPY */56 :
        return "JPY";
    case /* KZT */57 :
        return "KZT";
    case /* JOD */58 :
        return "JOD";
    case /* KES */59 :
        return "KES";
    case /* KPW */60 :
        return "KPW";
    case /* KRW */61 :
        return "KRW";
    case /* KWD */62 :
        return "KWD";
    case /* KGS */63 :
        return "KGS";
    case /* LAK */64 :
        return "LAK";
    case /* LBP */65 :
        return "LBP";
    case /* LSL */66 :
        return "LSL";
    case /* LRD */67 :
        return "LRD";
    case /* LYD */68 :
        return "LYD";
    case /* LTL */69 :
        return "LTL";
    case /* MOP */70 :
        return "MOP";
    case /* MWK */71 :
        return "MWK";
    case /* MYR */72 :
        return "MYR";
    case /* MVR */73 :
        return "MVR";
    case /* MRO */74 :
        return "MRO";
    case /* MUR */75 :
        return "MUR";
    case /* MXN */76 :
        return "MXN";
    case /* MNT */77 :
        return "MNT";
    case /* MDL */78 :
        return "MDL";
    case /* MAD */79 :
        return "MAD";
    case /* OMR */80 :
        return "OMR";
    case /* NAD */81 :
        return "NAD";
    case /* NPR */82 :
        return "NPR";
    case /* ANG */83 :
        return "ANG";
    case /* AWG */84 :
        return "AWG";
    case /* VUV */85 :
        return "VUV";
    case /* NZD */86 :
        return "NZD";
    case /* NIO */87 :
        return "NIO";
    case /* NGN */88 :
        return "NGN";
    case /* NOK */89 :
        return "NOK";
    case /* PKR */90 :
        return "PKR";
    case /* PAB */91 :
        return "PAB";
    case /* PGK */92 :
        return "PGK";
    case /* PYG */93 :
        return "PYG";
    case /* PEN */94 :
        return "PEN";
    case /* PHP */95 :
        return "PHP";
    case /* QAR */96 :
        return "QAR";
    case /* RUB */97 :
        return "RUB";
    case /* RWF */98 :
        return "RWF";
    case /* SHP */99 :
        return "SHP";
    case /* STD */100 :
        return "STD";
    case /* SAR */101 :
        return "SAR";
    case /* SCR */102 :
        return "SCR";
    case /* SLL */103 :
        return "SLL";
    case /* SGD */104 :
        return "SGD";
    case /* VND */105 :
        return "VND";
    case /* SOS */106 :
        return "SOS";
    case /* ZAR */107 :
        return "ZAR";
    case /* SSP */108 :
        return "SSP";
    case /* SZL */109 :
        return "SZL";
    case /* SEK */110 :
        return "SEK";
    case /* CHF */111 :
        return "CHF";
    case /* SYP */112 :
        return "SYP";
    case /* THB */113 :
        return "THB";
    case /* TOP */114 :
        return "TOP";
    case /* TTD */115 :
        return "TTD";
    case /* AED */116 :
        return "AED";
    case /* TND */117 :
        return "TND";
    case /* UGX */118 :
        return "UGX";
    case /* MKD */119 :
        return "MKD";
    case /* EGP */120 :
        return "EGP";
    case /* GBP */121 :
        return "GBP";
    case /* TZS */122 :
        return "TZS";
    case /* USD */123 :
        return "USD";
    case /* UYU */124 :
        return "UYU";
    case /* UZS */125 :
        return "UZS";
    case /* WST */126 :
        return "WST";
    case /* YER */127 :
        return "YER";
    case /* TWD */128 :
        return "TWD";
    case /* CUC */129 :
        return "CUC";
    case /* ZWL */130 :
        return "ZWL";
    case /* TMT */131 :
        return "TMT";
    case /* GHS */132 :
        return "GHS";
    case /* VEF */133 :
        return "VEF";
    case /* SDG */134 :
        return "SDG";
    case /* UYI */135 :
        return "UYI";
    case /* RSD */136 :
        return "RSD";
    case /* MZN */137 :
        return "MZN";
    case /* AZN */138 :
        return "AZN";
    case /* RON */139 :
        return "RON";
    case /* CHE */140 :
        return "CHE";
    case /* CHW */141 :
        return "CHW";
    case /* TRY */142 :
        return "TRY";
    case /* XAF */143 :
        return "XAF";
    case /* XCD */144 :
        return "XCD";
    case /* XOF */145 :
        return "XOF";
    case /* XPF */146 :
        return "XPF";
    case /* XBA */147 :
        return "XBA";
    case /* XBB */148 :
        return "XBB";
    case /* XBC */149 :
        return "XBC";
    case /* XBD */150 :
        return "XBD";
    case /* XAU */151 :
        return "XAU";
    case /* XDR */152 :
        return "XDR";
    case /* XAG */153 :
        return "XAG";
    case /* XPT */154 :
        return "XPT";
    case /* XPD */155 :
        return "XPD";
    case /* XUA */156 :
        return "XUA";
    case /* ZMW */157 :
        return "ZMW";
    case /* SRD */158 :
        return "SRD";
    case /* MGA */159 :
        return "MGA";
    case /* COU */160 :
        return "COU";
    case /* AFN */161 :
        return "AFN";
    case /* TJS */162 :
        return "TJS";
    case /* AOA */163 :
        return "AOA";
    case /* BYR */164 :
        return "BYR";
    case /* BGN */165 :
        return "BGN";
    case /* CDF */166 :
        return "CDF";
    case /* BAM */167 :
        return "BAM";
    case /* EUR */168 :
        return "EUR";
    case /* MXV */169 :
        return "MXV";
    case /* UAH */170 :
        return "UAH";
    case /* GEL */171 :
        return "GEL";
    case /* BOV */172 :
        return "BOV";
    case /* PLN */173 :
        return "PLN";
    case /* BRL */174 :
        return "BRL";
    case /* CLF */175 :
        return "CLF";
    case /* XSU */176 :
        return "XSU";
    case /* USN */177 :
        return "USN";
    
  }
}

function from_string_exn(s) {
  switch (s) {
    case "AED" :
        return /* AED */116;
    case "AFN" :
        return /* AFN */161;
    case "ALL" :
        return /* ALL */1;
    case "AMD" :
        return /* AMD */8;
    case "ANG" :
        return /* ANG */83;
    case "AOA" :
        return /* AOA */163;
    case "ARS" :
        return /* ARS */3;
    case "AUD" :
        return /* AUD */4;
    case "AWG" :
        return /* AWG */84;
    case "AZN" :
        return /* AZN */138;
    case "BAM" :
        return /* BAM */167;
    case "BBD" :
        return /* BBD */9;
    case "BDT" :
        return /* BDT */7;
    case "BGN" :
        return /* BGN */165;
    case "BHD" :
        return /* BHD */6;
    case "BIF" :
        return /* BIF */18;
    case "BMD" :
        return /* BMD */10;
    case "BND" :
        return /* BND */16;
    case "BOB" :
        return /* BOB */12;
    case "BOV" :
        return /* BOV */172;
    case "BRL" :
        return /* BRL */174;
    case "BSD" :
        return /* BSD */5;
    case "BTN" :
        return /* BTN */11;
    case "BWP" :
        return /* BWP */13;
    case "BYR" :
        return /* BYR */164;
    case "BZD" :
        return /* BZD */14;
    case "CAD" :
        return /* CAD */20;
    case "CDF" :
        return /* CDF */166;
    case "CHE" :
        return /* CHE */140;
    case "CHF" :
        return /* CHF */111;
    case "CHW" :
        return /* CHW */141;
    case "CLF" :
        return /* CLF */175;
    case "CLP" :
        return /* CLP */24;
    case "CNY" :
        return /* CNY */25;
    case "COP" :
        return /* COP */26;
    case "COU" :
        return /* COU */160;
    case "CRC" :
        return /* CRC */28;
    case "CUC" :
        return /* CUC */129;
    case "CUP" :
        return /* CUP */30;
    case "CURRENCY_UNSPECIFIED" :
        return /* CURRENCY_UNSPECIFIED */0;
    case "CVE" :
        return /* CVE */21;
    case "CZK" :
        return /* CZK */31;
    case "DJF" :
        return /* DJF */39;
    case "DKK" :
        return /* DKK */32;
    case "DOP" :
        return /* DOP */33;
    case "DZD" :
        return /* DZD */2;
    case "EGP" :
        return /* EGP */120;
    case "ERN" :
        return /* ERN */36;
    case "ETB" :
        return /* ETB */35;
    case "EUR" :
        return /* EUR */168;
    case "FJD" :
        return /* FJD */38;
    case "FKP" :
        return /* FKP */37;
    case "GBP" :
        return /* GBP */121;
    case "GEL" :
        return /* GEL */171;
    case "GHS" :
        return /* GHS */132;
    case "GIP" :
        return /* GIP */41;
    case "GMD" :
        return /* GMD */40;
    case "GNF" :
        return /* GNF */43;
    case "GTQ" :
        return /* GTQ */42;
    case "GYD" :
        return /* GYD */44;
    case "HKD" :
        return /* HKD */47;
    case "HNL" :
        return /* HNL */46;
    case "HRK" :
        return /* HRK */29;
    case "HTG" :
        return /* HTG */45;
    case "HUF" :
        return /* HUF */48;
    case "IDR" :
        return /* IDR */51;
    case "ILS" :
        return /* ILS */54;
    case "INR" :
        return /* INR */50;
    case "IQD" :
        return /* IQD */53;
    case "IRR" :
        return /* IRR */52;
    case "ISK" :
        return /* ISK */49;
    case "JMD" :
        return /* JMD */55;
    case "JOD" :
        return /* JOD */58;
    case "JPY" :
        return /* JPY */56;
    case "KES" :
        return /* KES */59;
    case "KGS" :
        return /* KGS */63;
    case "KHR" :
        return /* KHR */19;
    case "KMF" :
        return /* KMF */27;
    case "KPW" :
        return /* KPW */60;
    case "KRW" :
        return /* KRW */61;
    case "KWD" :
        return /* KWD */62;
    case "KYD" :
        return /* KYD */22;
    case "KZT" :
        return /* KZT */57;
    case "LAK" :
        return /* LAK */64;
    case "LBP" :
        return /* LBP */65;
    case "LKR" :
        return /* LKR */23;
    case "LRD" :
        return /* LRD */67;
    case "LSL" :
        return /* LSL */66;
    case "LTL" :
        return /* LTL */69;
    case "LYD" :
        return /* LYD */68;
    case "MAD" :
        return /* MAD */79;
    case "MDL" :
        return /* MDL */78;
    case "MGA" :
        return /* MGA */159;
    case "MKD" :
        return /* MKD */119;
    case "MMK" :
        return /* MMK */17;
    case "MNT" :
        return /* MNT */77;
    case "MOP" :
        return /* MOP */70;
    case "MRO" :
        return /* MRO */74;
    case "MUR" :
        return /* MUR */75;
    case "MVR" :
        return /* MVR */73;
    case "MWK" :
        return /* MWK */71;
    case "MXN" :
        return /* MXN */76;
    case "MXV" :
        return /* MXV */169;
    case "MYR" :
        return /* MYR */72;
    case "MZN" :
        return /* MZN */137;
    case "NAD" :
        return /* NAD */81;
    case "NGN" :
        return /* NGN */88;
    case "NIO" :
        return /* NIO */87;
    case "NOK" :
        return /* NOK */89;
    case "NPR" :
        return /* NPR */82;
    case "NZD" :
        return /* NZD */86;
    case "OMR" :
        return /* OMR */80;
    case "PAB" :
        return /* PAB */91;
    case "PEN" :
        return /* PEN */94;
    case "PGK" :
        return /* PGK */92;
    case "PHP" :
        return /* PHP */95;
    case "PKR" :
        return /* PKR */90;
    case "PLN" :
        return /* PLN */173;
    case "PYG" :
        return /* PYG */93;
    case "QAR" :
        return /* QAR */96;
    case "RON" :
        return /* RON */139;
    case "RSD" :
        return /* RSD */136;
    case "RUB" :
        return /* RUB */97;
    case "RWF" :
        return /* RWF */98;
    case "SAR" :
        return /* SAR */101;
    case "SBD" :
        return /* SBD */15;
    case "SCR" :
        return /* SCR */102;
    case "SDG" :
        return /* SDG */134;
    case "SEK" :
        return /* SEK */110;
    case "SGD" :
        return /* SGD */104;
    case "SHP" :
        return /* SHP */99;
    case "SLL" :
        return /* SLL */103;
    case "SOS" :
        return /* SOS */106;
    case "SRD" :
        return /* SRD */158;
    case "SSP" :
        return /* SSP */108;
    case "STD" :
        return /* STD */100;
    case "SVC" :
        return /* SVC */34;
    case "SYP" :
        return /* SYP */112;
    case "SZL" :
        return /* SZL */109;
    case "THB" :
        return /* THB */113;
    case "TJS" :
        return /* TJS */162;
    case "TMT" :
        return /* TMT */131;
    case "TND" :
        return /* TND */117;
    case "TOP" :
        return /* TOP */114;
    case "TRY" :
        return /* TRY */142;
    case "TTD" :
        return /* TTD */115;
    case "TWD" :
        return /* TWD */128;
    case "TZS" :
        return /* TZS */122;
    case "UAH" :
        return /* UAH */170;
    case "UGX" :
        return /* UGX */118;
    case "USD" :
        return /* USD */123;
    case "USN" :
        return /* USN */177;
    case "UYI" :
        return /* UYI */135;
    case "UYU" :
        return /* UYU */124;
    case "UZS" :
        return /* UZS */125;
    case "VEF" :
        return /* VEF */133;
    case "VND" :
        return /* VND */105;
    case "VUV" :
        return /* VUV */85;
    case "WST" :
        return /* WST */126;
    case "XAF" :
        return /* XAF */143;
    case "XAG" :
        return /* XAG */153;
    case "XAU" :
        return /* XAU */151;
    case "XBA" :
        return /* XBA */147;
    case "XBB" :
        return /* XBB */148;
    case "XBC" :
        return /* XBC */149;
    case "XBD" :
        return /* XBD */150;
    case "XCD" :
        return /* XCD */144;
    case "XDR" :
        return /* XDR */152;
    case "XOF" :
        return /* XOF */145;
    case "XPD" :
        return /* XPD */155;
    case "XPF" :
        return /* XPF */146;
    case "XPT" :
        return /* XPT */154;
    case "XSU" :
        return /* XSU */176;
    case "XUA" :
        return /* XUA */156;
    case "YER" :
        return /* YER */127;
    case "ZAR" :
        return /* ZAR */107;
    case "ZMW" :
        return /* ZMW */157;
    case "ZWL" :
        return /* ZWL */130;
    default:
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_name",
                  VAL: s
                });
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    }, Currency, {
      name: name,
      to_int: to_int,
      from_int: from_int,
      from_int_exn: from_int_exn,
      to_string: to_string,
      from_string_exn: from_string_exn
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "Currency"
        ]]
    }, V1, {
      Currency: Currency
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "Currency"
              ]]
          },
          "V1"
        ]]
    }, Common, {
      V1: V1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "Currency"
                    ]]
                },
                "V1"
              ]]
          },
          "Common"
        ]]
    }, Buhta, {
      Common: Common
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
